import { render, staticRenderFns } from "./WaterAttr.vue?vue&type=template&id=38581ac5&scoped=true&"
import script from "./WaterAttr.vue?vue&type=script&lang=js&"
export * from "./WaterAttr.vue?vue&type=script&lang=js&"
import style0 from "./WaterAttr.vue?vue&type=style&index=0&id=38581ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38581ac5",
  null
  
)

export default component.exports